module.exports = __webpack_public_path__ + "static/media/32pic.c4bb909e.jpg";